import { Optional } from 'functions/promiseExtensions';
import * as RangeWithId from 'types/_general/Search/RangeWithId';

export type Type = {
	id: string;
	left: number | null;
	right: number | null;
};

export function create(): Type {
	return {
		id: '',
		left: null,
		right: null,
	};
}

export function mapToApi(obj: Type): RangeWithId.Type {
	return {
		id: obj.id,
		minimum: obj.left,
		maximum: obj.right,
	};
}

export type ChangeSliderInput = {
	id: string;
	left: number | null;
	right: number | null;
	maximum: number | null;
	minimum: number | null;
};

export function updateSlider(slider: Type, input: ChangeSliderInput): Type {
	if (slider.id !== input.id) return slider;
	const left = Optional.Maybe<number | null>(input.left).map((left) => ({
		...slider,
		left: left,
	}));
	const right = Optional.Maybe<number | null>(input.right).map((right) => ({
		...slider,
		right: right,
	}));
	return left.or(right).getOrDefault(slider);
}

export function createFromInput(input: ChangeSliderInput): Type {
	return {
		id: input.id,
		left: input.left ?? input.minimum,
		right: input.right ?? input.maximum,
	};
}
